import { RouterEvent } from '@angular/router';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';
import { Role } from 'src/app/data/role';

export const navItems: NavItem[] = [
  // CITAS
  {
    displayName: 'Citas',
    iconName: 'calendar-event',
    bgcolor: 'primary',
    role: [Role.Administrador, Role.Sistemas, Role.JefaturaKardex, Role.Kardex, Role.AuxiliarPresidencia],
    children: [
          { displayName: 'Listado de citas', iconName: 'list', route: '/citas-listado', bgcolor: 'primary', role: [Role.Administrador, Role.JefaturaKardex, Role.Kardex, Role.AuxiliarPresidencia] },
          ],
        },
  // KARDEX
  {
    displayName: 'Kárdex',
    iconName: 'users-group',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Nuevo socio',
        iconName: 'users-plus',
        route: '/socio-nuevo',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.Archivo, Role.Legal,
              Role.Kardex,  Role.JefaturaKardex, Role.AuxiliarPresidencia, Role.Sistemas, Role.AuxiliarTesoreria]
      },
      { separator: true },
      {
        displayName: 'Mis turnos asignados',
        iconName: 'user-check',
        route: '/citas-zona-atencion',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.JefaturaKardex, Role.Kardex],
      },
      {
        displayName: 'Expedientes por cita',
        iconName: 'folder-share',
        route: '/kardex-expedientes-citas',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.JefaturaKardex, Role.Kardex],
      },
      {
        displayName: 'Mis tickets',
        iconName: 'user-question',
        route: '/solicitudes',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Archivo, Role.MesaDefuncion, Role.Legal, Role.MesaTestamentacion, Role.Administrador, 
              Role.Kardex, Role.JefaturaKardex, Role.AuxiliarPresidencia, Role.Sistemas, Role.AuxiliarTesoreria]
      },
      { separator: true },
      {
        displayName: 'Envío masivo de notificaciones',
        iconName: 'bell-ringing',
        route: '/envio-masivo-notificaciones',
        bgcolor: 'primary',
        role: [Role.Administrador],
      },
      {
        displayName: 'Impresión de etiquetas',
        iconName: 'printer',
        route: '/impresion-etiquetas',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Archivo, Role.Legal, Role.Administrador, 
              Role.Kardex, Role.Sistemas, Role.JefaturaKardex, Role.AuxiliarPresidencia, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Actualización de préstamo',
        iconName: 'calendar-stats',
        route: '/actualizacion-prestamo-fecha',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Archivo, Role.Legal, Role.MesaDefuncion, Role.MesaTestamentacion,
              Role.Administrador, Role.Kardex, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex,
              Role.AuxiliarPresidencia, Role.AuxiliarTesoreria]
      },
      { separator: true },
      {
        displayName: 'Asignación de Tickets',
        iconName: 'ticket',
        route: '/asignacion-tickets',
        bgcolor: 'primary',
        role:[Role.Administrador,
              Role.JefaturaKardex]
      },
      {
        displayName: 'Coordinación de turnos',
        iconName: 'layout-list',
        route: '/citas-zona-trabajo',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.JefaturaKardex],
      },
      {
        displayName: 'Estadísticas de turnos',
        iconName: 'chart-bar',
        route: '/kardex-estadisticas-turnos',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.JefaturaKardex],
      },
    ],
    role:[Role.Caja, Role.Archivo, Role.MesaDefuncion, Role.MesaTestamentacion, Role.Legal, Role.Administrador, Role.Kardex, Role.Sistemas, 
      Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarPresidencia, Role.AuxiliarTesoreria]
  },
  // ARCHIVO
  {
    displayName: 'Archivo',
    iconName: 'archive',
    bgcolor: 'primary',
    children:[
      {
      displayName: 'Solicitudes de archivo',
      iconName: 'folder-open',
      route: '/archivo-solicitudes',
      bgcolor: 'primary',
      role:[Role.Archivo, Role.Administrador]
      },
    ],
    role:[Role.Archivo, Role.Administrador]
  },

  // NÓMINAS
  {
    displayName: 'Nóminas',
    iconName: 'report-money',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Nómina ordinaria',
        iconName: 'file-import',
        route: '/procesa-nomina',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Nómina bancaria',
        iconName: 'file-dollar',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Procesamiento',
            iconName: 'loader',
            route: '/procesa-nomina-bancaria',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Excepciones',
            iconName: 'file-alert',
            route: '/procesa-nomina-bancaria-excepciones',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          }
        ],
      },
      {
        displayName: 'Nómina domiciliada',
        iconName: 'building-bank',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Procesamiento',
            iconName: 'loader',
            route: '/procesa-nomina-domiciliada',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Generación TXT',
            iconName: 'file-alert',
            route: '/genera-nomina-domiciliada-txt',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          }
        ],
      },
      {
        displayName: 'Nómina devoluciones',
        iconName: 'receipt-refund',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Procesamiento',
            iconName: 'loader',
            route: '/procesa-nomina-devoluciones',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          }
        ],
      },
      {
        displayName: 'Nómina foranea',
        iconName: 'world-dollar',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Procesamiento',
            iconName: 'loader',
            route: '/procesa-nomina-foranea',
            bgcolor: 'primary',
            role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
          }
        ],
      },
      {
        displayName: 'Cálculo de rendimientos',
        iconName: 'clock-dollar',
        route: '/calculo-rendimientos',
        bgcolor: 'primary',
        role:[Role.AuxiliarPresidencia, Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.JefaturaKardex, Role.AuxiliarTesoreria]
      }
      /* {
        displayName: 'Archivos procesados',
        iconName: 'file-check',
        route: '/cuotas',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.Sistemas]
      } */
    ],
    role:[Role.Administrador, Role.Sistemas, Role.Contabilidad, Role.AuxiliarPresidencia, Role.JefaturaKardex, Role.AuxiliarTesoreria]
  },
  // TESORERÍA
  {
    displayName: 'Tesorería',
    iconName: 'home-dollar',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Genera TXT',
        iconName: 'file-time',
        route: '/tesoreria-generaciontxt',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Pólizas de Pago',
        iconName: 'certificate',
        route: '/tesoreria-polizas',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.AuxiliarTesoreria, Role.AuxiliarPresidencia, Role.Contabilidad, Role.JefaturaKardex, Role.Sistemas]
      },
      {
        displayName: 'Dispersión de Pagos',
        iconName: 'file-dollar',
        route: '/tesoreria-dispersion-pagos',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.AuxiliarTesoreria, Role.AuxiliarPresidencia, Role.Contabilidad, Role.JefaturaKardex, Role.Sistemas]
      },
      {
        displayName: 'Reprogramación de Préstamo',
        iconName: 'device-imac-dollar',
        route: '/tesoreria-solicitudes-prestamo',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Descarga de Informacion',
        iconName: 'download',
        route: '/tesoreria-descarga-informacion',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.AuxiliarTesoreria, Role.AuxiliarPresidencia, Role.Contabilidad, Role.JefaturaKardex, Role.Sistemas]
      },
    ],
    role:[Role.Caja, Role.Administrador, Role.AuxiliarTesoreria, Role.AuxiliarPresidencia, Role.Contabilidad, Role.JefaturaKardex, Role.Sistemas]
  },
  // SECRETARÍA
  {
    displayName: 'Secretaría',
    iconName: 'file-text',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Impresión de documento',
        iconName: 'printer',
        route: '/secretaria-impresion-documento',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.MesaDefuncion, Role.MesaTestamentacion, Role.Sistemas, Role.Contabilidad]
          // Role.Secretaria se cambio por mesa defuncion
      },
    ],
    role:[Role.Administrador, Role.MesaDefuncion, Role.MesaTestamentacion, Role.Sistemas, Role.Contabilidad]
    // Role.Secretaria se cambio por mesa defuncion
  },
  // CAJA 
  {
    displayName: 'Caja',
    iconName: 'cash',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Recibos',
        iconName: 'receipt-2',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Recibos pendientes',
            iconName: 'file-time',
            route: '/caja-recibos',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Recibos cerrados',
            iconName: 'square-letter-x',
            route: '/caja-recibos-cerrados',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Recibos Bancarios',
            iconName: 'file-dollar',
            route: '/caja-recibos-bancarios',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          }
        ]
      },
      {
        displayName: 'Corte',
        iconName: 'report-money',
        route: '/caja-corte',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.AuxiliarTesoreria, Role.Contabilidad, Role.AuxiliarTesoreria]
      },
      
    ],
    role:[Role.Caja, Role.Administrador, Role.AuxiliarTesoreria, Role.Contabilidad, Role.AuxiliarTesoreria]
  },
  // CONTABILIDAD
  {
    displayName: 'Contabilidad',
    iconName: 'receipt-2',
    bgcolor: 'primary',
    children:[
      {
        displayName: 'Préstamos',
        iconName: 'device-imac-dollar',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria],
        children:[
          {
            displayName: 'Diferencias de pagos',
            iconName: 'file-diff',
            route: '/',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Préstamos con demasía',
            iconName: 'layers-difference',
            route: '/',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          },
          {
            displayName: 'Intereses de Préstamo',
            iconName: 'percentage',
            route: 'contabilidad-prestamo-intereses',
            bgcolor: 'primary',
            role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
          }
        ]
      },
      {
        displayName: 'Reporte',
        iconName: 'report-money',
        route: '/contabilidad-reporte',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador,Role.Contabilidad, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Consulta Reinversión',
        iconName: 'chart-line',
        route: '/contabilidad-consulta-reinversion',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador,Role.Contabilidad, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Consulta Demasías',
        iconName: 'cash',
        route: '/contabilidad-consulta-demasias',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador,Role.Contabilidad, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Búsqueda de recibos',
        iconName: 'file-search',
        route: '/contabilidad-busqueda-recibos',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
      },
      {
        displayName: 'Reportes Contables',
        iconName: 'file-spreadsheet',
        route: '/contabilidad-excel',
        bgcolor: 'primary',
        role:[Role.Caja, Role.Administrador,Role.Contabilidad, Role.AuxiliarTesoreria]
      },
    ],
    role:[Role.Caja, Role.Administrador, Role.Contabilidad, Role.AuxiliarTesoreria]
  },
  // ADMINISTRACIÓN
  {
    displayName: 'Administración',
    iconName: 'shield-cog',
    bgcolor: 'primary',
    role:[Role.Administrador, Role.JefaturaKardex, Role.Sistemas],
    children:[
      {
        displayName: 'Autorizaciones',
        iconName: 'key',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.JefaturaKardex],
        children:[
          {
            displayName: 'Token de Autorización',
            iconName: 'shield-lock',
            route: '/administracion-token-autorizacion',
            bgcolor: 'primary',
            role:[Role.Administrador, Role.JefaturaKardex]
          },
          {
            displayName: 'Configuración de Autorizadores',
            iconName: 'settings',
            route: '/administracion-config-autorizadores',
            bgcolor: 'primary',
            role:[Role.Administrador, Role.JefaturaKardex]
          },
          {
            displayName: 'Listado de Autorizaciones',
            iconName: 'list-check',
            route: '/administracion-listado-autorizaciones',
            bgcolor: 'primary',
            role:[Role.Administrador, Role.JefaturaKardex]
          },
          
        ]
      },
      // ANALÍTICA
      {
        displayName: 'Analítica',
        iconName: 'chart-dots',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.JefaturaKardex, Role.Contabilidad, Role.AuxiliarPresidencia],
        children:[
          {
            displayName: 'Tableros Operativos',
            iconName: 'layout-dashboard',
            bgcolor: 'primary',
            role:[Role.Administrador, Role.JefaturaKardex, Role.Contabilidad, Role.AuxiliarPresidencia],
            children:[
              {
                displayName: 'Usuarios Aplicación Móvil',
                iconName: 'device-analytics',
                route: '/analitica-usuarios-mobileapp',
                bgcolor: 'primary',
                role:[Role.Administrador, Role.JefaturaKardex]
              },
              {
                displayName: 'Tickets',
                iconName: 'ticket',
                route: '/analitica-tickets-dashboard',
                bgcolor: 'primary',
                role:[Role.Administrador, Role.JefaturaKardex]
              },
              {
                displayName: 'Finanzas productos',
                iconName: 'chart-bar',
                route: '/analitica-finanzas-dashboard',
                bgcolor: 'primary',
                role:[Role.Administrador, Role.Contabilidad, Role.AuxiliarPresidencia]
              }
            ]
          },
          {
            displayName: 'Tareas analítica tickets',
            iconName: 'robot',
            route: '/analitica-tickets-admin',
            bgcolor: 'primary',
            role:[Role.Administrador, Role.JefaturaKardex]
          }
        ]
      },
      {
        displayName: 'Citas',
        iconName: 'calendar-event',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.Sistemas],
        children: [
          { displayName: 'Parámetros generales', iconName: 'adjustments', route: '/citas-parametros', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
          { displayName: 'Medios del turnómetro', iconName: 'device-tv', route: '/citas-lobby-media', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
          { displayName: 'Representantes', iconName: 'users', route: '/citas-representantes', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
          { displayName: 'Tipos de cita', iconName: 'list', route: '/citas-tipos', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
          { displayName: 'Horarios institución', iconName: 'clock', route: '/citas-horarios-institucion', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
          { displayName: 'Excepciones institución', iconName: 'calendar-off', route: '/citas-excepciones-institucion', bgcolor: 'primary', role: [Role.Administrador, Role.Sistemas] },
        ],
      },

      // ADMINISTRACIÓN DE PÓLIZAS
      {
        displayName: 'Administración de pólizas',
        iconName: 'chart-dots',
        bgcolor: 'primary',
        role:[Role.Administrador],
        children:[
          {
            displayName: 'Montos de pólizas',
            iconName: 'certificate',
            route: '/admin-polizas',
            bgcolor: 'primary',
            role:[Role.Administrador]
          },
          {
            displayName: 'Pólizas Proporcionales',
            iconName: 'certificate',
            route: '/admin-polizas-proporcional',
            bgcolor: 'primary',
            role:[Role.Administrador]
          }
        ]
      },
      {
        displayName: 'Catálogos',
        iconName: 'books',
        bgcolor: 'primary',
        role: [Role.Administrador, Role.JefaturaKardex],
        children: [
          {
            displayName: 'Catálogo de fechas de aplicación',
            iconName: 'calendar-week',
            route: '/administracion-cat-fechas-aplicacion',
            bgcolor: 'primary',
            role: [Role.Administrador, Role.JefaturaKardex],
          },
          {
            displayName: 'Catálogo de intereses de préstamo',
            iconName: 'calendar-dollar',
            route: '/administracion-cat-intereses-prestamo',
            bgcolor: 'primary',
            role: [Role.Administrador, Role.JefaturaKardex],
          },
          {
            displayName: 'Catálogo Rendimientos Ahorro',
            iconName: 'chart-line',
            route: '/administracion-cat-rendimientos-ahorro',
            bgcolor: 'primary',
            role: [Role.Administrador, Role.JefaturaKardex],
          },
          {
displayName: 'Catálogo de bancos',
            iconName: 'building-bank',
            route: '/administracion-cat-bancos',
            bgcolor: 'primary',
            role: [Role.Administrador, Role.JefaturaKardex],
          },
          {
            displayName: 'Documentos',
            iconName: 'file-description',
            route: '/administracion-cat-documentos',
            bgcolor: 'primary',
            role: [Role.Administrador, Role.JefaturaKardex],
          },
        ],
      },
      {
        displayName: 'Parámetros del Sistema',
        iconName: 'settings',
        route: '/administracion-parametros',
        bgcolor: 'primary',
        role:[Role.Administrador, Role.JefaturaKardex]
      },
      {
        displayName: 'Usuarios',
        iconName: 'list-check',
        route: '/administracion-usuarios',
        bgcolor: 'primary',
        role:[Role.Administrador]
      },
      {
        displayName: 'Consentimientos legales',
        iconName: 'file-text',
        route: '/administracion-consentimientos',
        bgcolor: 'primary',
        role:[Role.Administrador]
      },
      {
        displayName: 'Administración de socios',
        iconName: 'users-minus',
        route: '/administracion-socios',
        bgcolor: 'primary',
        role:[Role.Administrador]
      }
    ]
  },
];
